import React from "react";
import { Link } from "react-router-dom";
import { FileText, ArrowRight } from "lucide-react";

const insights = [
  {
    number: "#42",
    date: "10/2025",
    title: "Human in the Loop: Neue Arbeitsteilung zwischen Menschen und KI",
    category: "Organisation",
  },
  {
    number: "#41",
    date: "10/2025",
    title: "KI & Organisation: Warum CEOs handeln müssen",
    category: "C-Level",
  },
  {
    number: "#40",
    date: "09/2025",
    title: "KI & Kostensenkung 2026: KI als schnellster Hebel zur Kostensenkung",
    category: "ROI",
  },
];

const LatestInsightsSection = () => {
  return (
    <section className="py-20 md:py-28 bg-surface-raised/50">
      <div className="container mx-auto px-4">
        <div className="max-w-[64ch] mb-12">
          <h2 className="text-[clamp(1.9rem,3.6vw,3rem)] font-extrabold tracking-[-0.032em] leading-[1.06] [text-wrap:balance] text-white mb-5">
            Aktuelle Insights
          </h2>
          <p className="text-[1.05rem] leading-relaxed text-ink-muted max-w-[62ch]">
            Über 42 White Papers zu KI-Transformation, Strategie und messbarem Business Impact
          </p>
        </div>

        {/* Haarlinien-Zeilen statt Karten: die Beitraege sind eine Liste,
            keine gleichwertigen Kacheln. Titel traegt, Beiwerk tritt zurueck. */}
        <div className="border-t border-hairline">
          {insights.map((item, index) => (
            <Link
              key={index}
              to="/wissenscenter"
              className="group grid gap-2 border-b border-hairline py-7 transition-[background-color,padding] duration-300 ease-brand hover:bg-brand/[0.045] hover:pl-4 md:grid-cols-[190px_1fr_auto] md:items-baseline md:gap-8"
            >
              <span className="text-xs font-semibold uppercase tracking-[0.14em] text-brand-300">
                {item.category}
              </span>
              <h3 className="max-w-[60ch] text-[1.15rem] font-bold leading-snug tracking-[-0.02em] text-white transition-colors group-hover:text-brand-300">
                {item.title}
              </h3>
              <span className="text-xs tabular-nums text-ink-faint">
                {item.number} · {item.date}
              </span>
            </Link>
          ))}
        </div>

        <div className="mt-10">
          <Link
            to="/wissenscenter"
            className="inline-flex items-center gap-2 text-brand-400 hover:text-brand-300 text-sm font-medium transition-colors"
          >
            Alle 42+ White Papers ansehen
            <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default LatestInsightsSection;
